import FindJobIcon1 from '../assets/find-jobs/find-job-icon-1.png';
import FindJobIcon2 from '../assets/find-jobs/find-job-icon-2.png';
import FindJobIcon3 from '../assets/find-jobs/find-job-icon-3.png';
import InterviewIcon1 from '../assets/find-jobs/interview-icon-1.png';
import InterviewIcon2 from '../assets/find-jobs/interview-icon-2.png';

export const EMPLOYMENT_TYPE = Object.freeze({
    FULL_TIME: {
        displayValue : 'Full-Time',
        image : FindJobIcon1,
        secondaryText : '40 hours/week',
    },
    PART_TIME: {
        displayValue : 'Part-Time',
        image : FindJobIcon2,
        secondaryText : '20-35 hours/week',
    },
    NONE: {
        displayValue : 'None',
        image : FindJobIcon3,
        secondaryText : 'just checking around',
    }
});

export const SENIORITY_LEVEL = Object.freeze({
    JUNIOR : {
        displayValue : 'Junior'
    },
    INTERMEDIATE : {
        displayValue : 'Intermediate'
    },
    SENIOR : {
        displayValue : 'Senior'
    }
});

export const ENGLISH_LEVEL = Object.freeze({
    BEGINNER : {
        displayValue : 'Beginner',
        image : InterviewIcon1,
        primaryText : 'Ooph, better not',
        secondaryText : 'My English is good enough for written communication only',
    },
    INTERMEDIATE : {
        displayValue : 'Intermediate',
        image : InterviewIcon2,
        primaryText : 'Sure, no probem at all',
        secondaryText : 'I can handle both on interview and day-to-day work with English-speaking teammates',
    },
    FLUENT : {
        displayValue : 'Fluent',
        image : InterviewIcon2,
        primaryText : 'I am an expert',
        secondaryText : 'English is my native language',
    }
});
